module.exports = __webpack_public_path__ + "img/P150T_weapon_126.118141d2.png";